export const SET_SIDEMENU_DETAILS = "SET_SIDEMENU_DETAILS";
export const setSideMenuDetails = (key, res) => ({
  type: SET_SIDEMENU_DETAILS,
  res,
  key,
});
